import { api } from "@/lib/api";

const LOCAL = { trailers: "fhp-load-trailers", customers: "fhp-load-customers" };
export const STARTER_TRAILER = {
  name: "My trailer (5 pockets)", tare_weight: 28000, max_gross: 80000, diesel_in_double: false,
  compartments: [3100, 1100, 1100, 1000, 2800].map((capacity, i) => ({ name: `C${i + 1}`, capacity, locked_dry: false, double_bulkhead: false })),
};

const readLocal = (kind) => { try { return JSON.parse(localStorage.getItem(LOCAL[kind])) || []; } catch { return []; } };
const writeLocal = (kind, list) => { localStorage.setItem(LOCAL[kind], JSON.stringify(list)); return list; };

// Signed-in drivers save to their account; signed-out drivers keep things on this phone.
export function loadStore(signedIn) {
  const kind = (k) => ({
    list: async () => {
      if (signedIn) return api.loadList(k);
      const items = readLocal(k);
      if (!items.length && k === "trailers") return writeLocal(k, [{ ...STARTER_TRAILER, id: "local-starter" }]);
      return items;
    },
    add: async (body) => (signedIn ? api.loadAdd(k, body)
      : (() => { const doc = { ...body, id: `local-${crypto.randomUUID()}` }; writeLocal(k, [...readLocal(k), doc]); return doc; })()),
    update: async (id, body) => (signedIn ? api.loadUpdate(k, id, body)
      : (() => { const doc = { ...body, id }; writeLocal(k, readLocal(k).map((x) => (x.id === id ? doc : x))); return doc; })()),
    remove: async (id) => (signedIn ? api.loadRemove(k, id) : writeLocal(k, readLocal(k).filter((x) => x.id !== id))),
  });
  return { trailers: kind("trailers"), customers: kind("customers") };
}

export const toPayload = (t) => ({ name: t.name, compartments: t.compartments, tare_weight: t.tare_weight, max_gross: t.max_gross, diesel_in_double: !!t.diesel_in_double });
